import { cn } from "@/utils/cn";

export const getRatingStyles = (className?: string) => {
  /**
   * Estilos para o container flex que agrupa as estrelas.
   */
  const container = cn("inline-flex items-center gap-1", className);

  /**
   * Função que retorna os estilos para um ícone de estrela individual.
   * @param isFilled Define se a estrela está preenchida ou vazia.
   */
  const star = (isFilled: boolean) =>
    cn("transition-colors", {
      // Cor 'warning' do tailwind.config.ts (#E6E676)
      "text-warning": isFilled,
      // Cor 'dark-100' do tailwind.config.ts (#D0D1D3)
      "text-dark-100": !isFilled,
    });

  return { container, star };
};
